import * as constants from '../../constants'
import { IMap, IIntegrationState, IStoreState } from '../../../types'
import { IIntegrationActions } from '../../actions/integrations'

const initState = {
  metadata: {
    fetching: false,
    fetchingError: '',
    fetchingSuccess: '',
    processing: false,
    processingError: '',
    processingSuccess: '',
    lastUpdated: Date.now()
  },
  items: {}
}
export function integrations(state: IIntegrationState, action: IIntegrationActions): IIntegrationState {
  if (typeof state === 'undefined') {
    return initState
  }
  switch (action.type) {
    case constants.FETCH_INTEGRATIONS_REQUEST: {
      return {
        ...state,
        metadata: { ...state.metadata, fetching: true }
      }
    }
    case constants.FETCH_INTEGRATIONS_SUCCESS: {
      const items = {}
      action.payload.forEach(integration => {
        items[integration.uuid] = integration
      })
      return {
        ...state,
        items,
        metadata: { ...state.metadata, fetching: false }
      }
    }
    case constants.FETCH_INTEGRATIONS_FAIL: {
      return {
        ...state,
        metadata: {
          ...state.metadata,
          fetching: true,
          fetchingError: action.payload
        }
      }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/integrations/index.ts